import { useEffect, useState } from "react";
import { useParams, Link } from "react-router-dom";
import api from "@/lib/api";
import { LOGO_URL } from "@/lib/constants";
import { Star } from "lucide-react";

export default function SharedReview() {
  const { slug } = useParams();
  const [review, setReview] = useState(null);
  const [notFound, setNotFound] = useState(false);

  useEffect(() => {
    api.get(`/reviews/${slug}`).then(({ data }) => setReview(data)).catch(() => setNotFound(true));
  }, [slug]);

  if (notFound) return <p className="text-center py-24 font-heading">Review not found.</p>;
  if (!review) return <p className="text-center py-24 font-heading">Loading…</p>;

  return (
    <div className="max-w-lg mx-auto px-4 py-20 text-center">
      <img src={LOGO_URL} alt="Care-4U" className="h-16 mx-auto" />
      <div className="card-metal p-8 mt-6">
        <span className="inline-flex items-center gap-1 font-heading font-black text-3xl text-[#9b111e]">
          <Star className="w-7 h-7 fill-[#9b111e]" /> {review.rating}/10
        </span>
        <h1 className="font-heading font-black text-xl mt-4">{review.provider_name}</h1>
        <p className="text-sm text-slate-500">{review.service}</p>
        <p className="text-slate-700 mt-4 text-lg">“{review.comment}”</p>
        <p className="text-xs text-slate-400 mt-3">— {review.client_name}</p>
      </div>
      <Link to="/" className="btn-red-3d inline-block mt-8" data-testid="shared-review-cta">
        Visit Care-4U.net
      </Link>
    </div>
  );
}
